import $ from 'jquery';
import inView from 'in-view';

init();

function init() {
  inView('.lazy-jux')
    .on('enter', handleLazyJux);
}

function handleLazyJux(elm) {
  const $this = $(elm);
  if (!$this.hasClass('juxtapose-loaded')) {
    createSlider($this );

    $this
      .addClass('juxtapose-loaded')
      .parents('.juxtapose-wrapper')
      .append($('<div />')
      .addClass('calltoaction')
      .html('<img src="images/slider/hand-slider.svg" /><span class="calltoaction-text callToAction">Verschieben</span>'));
  }
}

function createSlider(elm) {
  const isMobile = window.innerWidth < 768;
  new window.juxtapose.JXSlider(`#${elm.attr('id')}`, [{
    src: isMobile ? elm.attr('data-left-image') : elm.attr('data-left-image-desktop'),
    label: elm.attr('data-left-label')
  }, {
    src: isMobile ? elm.attr('data-right-image') :  elm.attr('data-right-image-desktop'),
    label: elm.attr('data-right-label')
  }], {
    animate: false,
    showLabels: true,
    showCredits: false,
    startingPosition: elm.parents('.content-box').attr('data-startpos') || '50%'
  });
}